<div
  class="flex items-center justify-between rounded-[8px] rounded-md border border-[#e47676] bg-[#f98989]"
  matSnackBarLabel
>
  <div class="flex items-center gap-[8px]">
    <mat-icon class="h-[20px] w-[20px] text-[#5e1e1e]" svgIcon="error" />
    <h1 class="text-[0.8rem] text-[#583636]">{{ snackBarVar.message }}</h1>
  </div>
</div>
